<template>
  <md-card-content>
    <div class="md-layout md-gutter">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
        <label>利用規約の確認</label>
      </div>
      <div class="md-layout-item md-size-30">
        <md-field>
          <label v-if="apply">上記利用規約に同意します</label>
        </md-field>
      </div>
    </div>
  </md-card-content>
</template>

<script>
export default {
  name : 'ContractPreviewTerm',
  props: ['apply'],
}
</script>

<style lang="scss" scoped>
</style>
